import * as React from 'react';
import { Formik, Form } from 'formik';
import { useTranslation } from 'react-i18next';
import { ConnectedFocusError } from 'focus-formik-error';
import { useDispatch } from 'react-redux';
import * as Yup from 'yup';
import Button from '../../../components/Button';
import useAddressFields, { AddressSelectionFields } from '../Fields';
import { setSelectedGeoLocation } from '../../../store/actions/GeoLocation';
import { opzetApi } from '../../../store/slices/OpzetApi';
import SubmitUrlParams from '../SubmitUrlParams';

type Props = {
  buttonLabel?: string;
};

const AddressSelectionForm = (props: Props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const {
    buttonLabel = t('address_selection.form.button.submit'),
  } = props;

  const {
    submit,
    initialValues,
    validationScheme,
    props: addressFieldProps,
  } = useAddressFields({
    queryHooks: opzetApi.endpoints.addressSuggest,
    queryMapper: {
      uid: 'bagid',
      house_number: 'huisnummer',
      house_number_extension: 'toevoeging',
      house_letter: 'huisletter',
      city: 'woonplaats',
      postal_code: 'postcode',
      street: 'straat',
    },
  });

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={Yup.object()
        .shape({
          ...validationScheme,
        })}
      onSubmit={async (values, helpers) => {
        helpers.setSubmitting(true);

        const address = await submit(values, helpers);

        if (!address) {
          helpers.setSubmitting(false);
          return;
        }

        dispatch(setSelectedGeoLocation({ data: address }));

        helpers.setSubmitting(false);
      }}
    >
      {({
        isSubmitting,
      }) => {
        return (
          <Form>
            <SubmitUrlParams />
            <ConnectedFocusError />
            <AddressSelectionFields
              {...addressFieldProps}
              noResultsError={t('address_selection.form.error.not_hvc_waste_address')}
            />
            <div className="form-item">
              <Button
                type="primary"
                htmlType="submit"
                onClick={() => {}}
                isLoading={isSubmitting}
                disabled={isSubmitting}
              >
                {buttonLabel}
              </Button>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default AddressSelectionForm;
